export function waitForFacebookBrowser () {
  return waitUntil(() => {
    return document.documentElement
      && window.innerWidth === document.documentElement.clientWidth
      && window.innerHeight === document.documentElement.clientHeight;
  });
}


export function isFacebookApp () {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
}

function waitUntil (condition, interval = 50, times = 10) {
  return new Promise((resolve, reject) => {
    let counter = times;

    const runCheck = () => {
      try {
        const conditionResult = condition();

        counter -= 1;
        window.counter = counter;
        if (counter === 0 || conditionResult) {
          resolve(conditionResult);
        } else {
          setTimeout(runCheck, interval);
        }
      } catch (err) {
        reject(err);
      }
    };

    setTimeout(runCheck, interval);
  });
}



// WEBPACK FOOTER //
// ./src/lib/wait-for-facebook-browser.js